import { colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { keyframes } from 'styled-components';

import * as behavioral from './behavioral';

type VersionData = {
  revision: string; // git commit hash
  version: string; // package version
};

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const StyledUpdateAvailable = styled.div`
  width: 400px;
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: 1337;
  padding: 16px;
  border-radius: 8px;
  background-color: ${cssThemedValue({ light: colors.pepper100, dark: colors.salt100 })};
  color: ${cssThemedValue({ light: colors.salt100, dark: colors.pepper100 })};
  cursor: pointer;
  /* ignore-color */
  box-shadow: 0 12px 12px 0 ${colors.pepper24};
  backdrop-filter: blur(10px);
  animation: ${fadeIn} 0.2s;
`;

const Title = styled.div`
  font-weight: bold;
`;

const Content = styled.div`
  margin-block-start: 10px;
`;

const POLL_INTERVAL = 1000 * 60 * 60; // 1 hour

const UpdateAvailable = () => {
  const { data: hasUpdate } = useQuery(
    ['check-version-update'],
    async () => {
      const response = await window.fetch('/version.json');
      const versionData: VersionData = await response.json();
      return process.env.APP_REVISION !== versionData.revision;
    },
    { refetchInterval: POLL_INTERVAL },
  );

  const applyUpdate = () => {
    behavioral.reportVersionUpdateApply();
    window.location.reload();
  };

  if (!hasUpdate) {
    return null;
  }

  return (
    <StyledUpdateAvailable onClick={applyUpdate}>
      <Title>
        <FormattedMessage id="update-available.title" />
      </Title>
      <Content>
        <FormattedMessage id="update-available.content" />
      </Content>
    </StyledUpdateAvailable>
  );
};

export default UpdateAvailable;
